import React, { useState, useEffect } from 'react';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import ActionDialog from './ActionDialog';
import { GRADE_LABELS } from '../../utils/formatter';

const GRADES = Object.entries(GRADE_LABELS).map(([value, label]) => ({ value, label }));

const GradeChangeDialog = ({ open, onClose, onConfirm, currentGrade }) => {
  const [selectedGrade, setSelectedGrade] = useState(currentGrade || GRADES[0].value);

  useEffect(() => {
    if (open) {
      setSelectedGrade(currentGrade || GRADES[0].value);
    }
  }, [open, currentGrade]);

  const handleConfirm = () => {
    onConfirm(selectedGrade);
  };

  return (
    <ActionDialog open={open} onClose={onClose} onConfirm={handleConfirm} title="등급 변경">
      <RadioGroup value={selectedGrade} onChange={(e) => setSelectedGrade(e.target.value)}>
        {GRADES.map((grade) => (
          <FormControlLabel
            key={grade.value}
            value={grade.value}
            control={<Radio size="small" />}
            label={grade.label}
            sx={{
              '& .MuiFormControlLabel-label': {
                fontSize: 14,
              },
            }}
          />
        ))}
      </RadioGroup>
    </ActionDialog>
  );
};

export default GradeChangeDialog;
